/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_CellarInputs */

const cs_enum_cellar = /** @type {(inputs: Enum_CellarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklep`)
};

const en_enum_cellar = /** @type {(inputs: Enum_CellarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cellar`)
};

/**
* | output |
* | --- |
* | "Cellar" |
*
* @param {Enum_CellarInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_cellar = /** @type {((inputs?: Enum_CellarInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_CellarInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_cellar(inputs)
	return cs_enum_cellar(inputs)
});